<ng-container *ngIf="status">
	<p>Voer voordat u doorgaat de code van uw verificatie-app in.</p>
	<form [formGroup]="otpForm" (ngSubmit)="authenticationService.regenerateTwoFactorRecoveryCodes(otpForm.value)">
		<mat-form-field>
			<input matInput placeholder="Code" type="number" required formControlName="code">
			<mat-error *ngIf="formService.getFieldError('code')">{{ formService.getFieldError('code') }}</mat-error>
		</mat-form-field>
		<button color="primary" mat-button [disabled]="!otpForm.valid">BEVESTIGEN</button>
	</form>
</ng-container>
<ng-container *ngIf="!status">
	<div class="alert alert-info" fxFlex fxLayoutAlign="center" fxLayout="row">
		<mat-icon>warning</mat-icon>
		<h2>Twee-factor-authenticatie is niet ingeschakeld op uw account.</h2>
	</div>
</ng-container>
